import React, { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppointmentRecommendations } from '@hooks/useAppointmentRecommendations';
import { useSessionOutcome } from '@hooks/useSessionOutcome';
import { css } from '@emotion/react';
import { SessionFormItem } from './SessionFormItem';
import { Cascader } from 'antd';

const cascaderStyles = css`
  width: 100%;
  position: relative;

  .ant-select-dropdown {
    max-width: 100%;
  }

  .ant-cascader-menu {
    max-width: 60%;
  }

  .ant-cascader-menu:first-child {
    min-width: fit-content;
  }

  .ant-cascader-menu-item {
    max-width: 100%;
  }

  .ant-cascader-menu-item-content {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SuggestedInvestigationsFormItem = (props: ComponentProps<typeof SessionFormItem>) => {
  const { t } = useTranslation('common');

  const { appointmentVersion } = useSessionOutcome();
  const { investigationsCascaderValue, investigationsMeta, onChangeInvestigations, readOnly } =
    useAppointmentRecommendations();

  if (!investigationsMeta) return null;

  const options = Object.keys(investigationsMeta).map((group) => ({
    value: group,
    label: group,
    children: investigationsMeta[group].map(({ service_type_code, service_type_desc }) => ({
      value: service_type_code,
      label: service_type_desc
    }))
  }));

  const label = appointmentVersion === 1 ? t('Investigations') : t('Lab tests');

  return (
    <SessionFormItem label={label} {...props} linkAria>
      <Cascader
        options={options}
        onChange={(values) => {
          const selectedInvestigations = values.map((item) => ({
            service_type_code: String(item[item.length - 1])
          }));
          onChangeInvestigations(selectedInvestigations);
        }}
        showCheckedStrategy={Cascader.SHOW_CHILD}
        value={investigationsCascaderValue}
        disabled={readOnly}
        css={cascaderStyles}
        multiple
        data-testid="investigation-cascader"
        getPopupContainer={(node) => node.closest('[data-testid="investigation-cascader"]')}
      />
    </SessionFormItem>
  );
};
